var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"app"},on:{"click":_vm.closeCart}},[_c('ToolBar'),_c('router-view'),_c('Footer'),_c('whatsAppFix'),(_vm.ifAutoModel)?_c('autoModal'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }